import React from 'react';
import Invite from './Invite';
import Layout from '../../components/Layout';
import getUser from "../../utils/getUser";

async function action({ fetch }) {
  let user = getUser();

  return {
    title: 'New Tab Studio',
    chunks: ['invite'],
    component: (
      <Layout>
        <Invite fetch={fetch} user={user} />
      </Layout>
    ),
  };
}

export default action;
